/**
 * Created by alvinoktavianus on 6/27/17.
 */

// Default dispatcher
export const INGREDIENT_SUBSCRIPTION_PAGE_REQUEST = 'INGREDIENT_SUBSCRIPTION_PAGE_REQUEST'
export const INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS = 'INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS'
export const INGREDIENT_SUBSCRIPTION_FEATURE_PRICE = 'INGREDIENT_SUBSCRIPTION_FEATURE_PRICE'
export const INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS = 'INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS'
export const INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE = 'INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE'
export const INGREDIENT_SUBSCRIPTION_END_TUTORIAL = 'INGREDIENT_SUBSCRIPTION_END_TUTORIAL'
export const INGREDIENT_SUBSCRIPTION_VERIFY_BILLING = 'INGREDIENT_SUBSCRIPTION_VERIFY_BILLING'
export const INGREDIENT_SUBSCRIPTION_START_TRIAL = 'INGREDIENT_SUBSCRIPTION_START_TRIAL'

// Setter
export const INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL = 'INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL'
export const INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS = 'INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS'
export const INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE = 'INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE'
export const INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE = 'INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE'
export const INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE = 'INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE'
export const INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL = 'INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL'
export const INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT = 'INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT'
export const INGREDIENT_SUBSCRIPTION_SET_OUTLETS = 'INGREDIENT_SUBSCRIPTION_SET_OUTLETS'
export const INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE = 'INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE'

// Getter
export const INGREDIENT_SUBSCRIPTION_GET_BILLINGS = 'INGREDIENT_SUBSCRIPTION_GET_BILLINGS'
export const INGREDIENT_SUBSCRIPTION_GET_OUTLETS = 'INGREDIENT_SUBSCRIPTION_GET_OUTLETS'

// Other dispatcher
export const INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON = 'INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON'
export const INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON = 'INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON'
export const INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL = 'INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL'
export const INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL = 'INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL'
export const INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = 'INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL'
export const INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = 'INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL'



// WEBPACK FOOTER //
// ./app/actions/ingredients/ingredientSubscription/constant.js